import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { ClickEventOptions, sendTealiumClickEvent } from 'utils/sendTealiumEvent'
import getSubdomain from 'utils/urls/getSubdomain'
import * as english from 'i18n/en'
import { useFocusOnElement } from 'hooks/useFocusOnElement'

export interface StepSuccessProps {
  handleOnInitialLoad: () => void;
}

const MEDICARE_SUBDOMAIN = getSubdomain(process.env.REACT_APP_MEDICARE_ENV ?? '')

export const Success: React.FC<StepSuccessProps> = ({ handleOnInitialLoad }) => {
  useEffect(() => {
    handleOnInitialLoad()
  }, [handleOnInitialLoad])

  // Set focus to success message on load
  useEffect(() => {
    document.getElementById('mcf-submitted-success-message')?.focus()
  }, [])

  const focusOnElement = useFocusOnElement()

  const { t } = useTranslation('mcfStep3Page')

  return (
    <div data-testid='form-success'>
      <div className='ds-l-form-row'>
        <div className='ds-l-col--12'>
          <h1 className='ds-text-heading--3xl my-c-main-header-margin' id='maincontent' tabIndex={-1}>{t('Medicare Complaint Form')}</h1>
          <h2 className='ds-text-heading--sm my-u-font-size--18'>{t('Step 3 of 3')}</h2>
          <h2 className='ds-text-heading--2xl my-u-mt--6'>{t('Complaint submitted')}</h2>
        </div>
      </div>
      <div data-testid='success-focus' tabIndex={-1} ref={focusOnElement} className='ds-c-alert ds-c-alert--hide-icon ds-c-alert--success my-u-my--20'>
        <div className='ds-c-alert__body'>
          <h2 className='my-c-main-header-success' id='mcf-submitted-success-message'>{t('Success!')}</h2>
          <p className='ds-c-alert__text'>
            {t('Your complaint has been submitted')}
          </p>
        </div>
      </div>
      <p className='my-u-mt--10 ds-u-font-size--lg'>{t('submit.moreInfo')}</p>
      <p className='ds-u-margin-bottom--6 ds-u-font-size--lg'>{t('submit.survey')}</p>
      <a
        href={`https://${MEDICARE_SUBDOMAIN}medicare.gov`}
        onClick={() => {
          sendTealiumClickEvent({
            event_action: 'Complaint submitted',
            event_label: 'CTA: ' + english.mcfStep3Page.home, // CTA + text untranslated
            event_name: 'medicare_complaint_form_ui_clicked',
            text: english.mcfStep3Page.home,
            event_type: 'ui interaction', // 'ui interaction' || "conversion" //conversion for interaction7
            page: 'Confirmation Page'
          } as ClickEventOptions)
        }}
        className='ds-c-button ds-c-button--solid'
      >{t('home')}
      </a>
    </div>
  )
}
